<!-- 达人概览 -->
<template>
  <div class="outlineContainer">
        <div class="part1 block-wrap" v-if="pjList.length">
            <div class="bigTitleBox">
                <div class="bigTitle">达人排竞信息</div>
            </div>
            <div class="tips"><i class="vxe-icon-warning-circle"></i>该达人目前已排期确定参与推广的游戏或游戏类型如下，若您有合作意向且营销标的与此类似，请谨慎考虑，以免撞档。</div>
            <vxe-table :data="pjList" :column-config="{ resizable: true }" :border="false" :show-header-overflow="true" :show-overflow="true" :show-footer="false" :align="'center'">
                <vxe-column field="" title="排竞日期">
                  <template #default="{ row }">
                    <span>{{ row.start_time }} 至 {{ row.end_time }}</span><span style="color:#FF6F28"> (还有{{ row?.end_time ? getDaysRemaining(row?.end_time) : '-' }}天排竞结束)</span>
                  </template>
                </vxe-column>
                <vxe-column field="competitive_product" title="排竞游戏或类型"></vxe-column>
            </vxe-table>
        </div>
        <div class="part1 block-wrap" v-if="!hideSupplierTable && supplierList.length">
            <div class="bigTitleBox" style="display: flex;justify-content: space-between;align-items: center;">
                <div class="bigTitle">供应商信息</div>
                <el-button type="text" @click="() => isSupplierListExpand = !isSupplierListExpand">
                    <span v-if="isSupplierListExpand">收起<i class="el-icon-arrow-down"></i></span>
                    <span v-else>展开<i class="el-icon-arrow-up"></i></span>
                </el-button>
            </div>
            <vxe-grid v-show="isSupplierListExpand" v-bind="supplierGridOptions" :data="supplierList" :row-class-name="rowClassName">
                <template #suppliers_name="{row}">
                    <div>{{ row.suppliers_name }}</div>
                    <div v-if="row.is_black == 1" style="color: #1D2129;">（该供应商已被拉黑）</div>
                </template>
            </vxe-grid >
        </div>
        <div class="part1 block-wrap" >
            <div class="bigTitleBox" style="display: flex;justify-content: space-between;align-items: center;">
                <div class="bigTitle">达人历史合作明细</div>
                <el-button type="text" @click="() => isCooperationExpand = !isCooperationExpand">
                    <span v-if="isCooperationExpand">收起<i class="el-icon-arrow-down"></i></span>
                    <span v-else>展开<i class="el-icon-arrow-up"></i></span>
                </el-button>
            </div>
            <div v-show="isCooperationExpand">
                <CooperationDetailTable  plat="抖音" :shortId="$route.query.shortid" @datachange="onCooperationDataChange"></CooperationDetailTable>
            </div>
        </div>
        <div v-if="darenID" class="part1 block-wrap">
            <!-- <div class="bigTitleBox">
            <span class="bigTitle">商业能力</span>
            <el-dropdown trigger="click" @command="industryClick">
                <span class="el-dropdown-link">
                    {{ "行业:"+industryData.category_name }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item,index) in industry" :command="item" :key="index">{{item.category_name}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="linkInfoPart" v-loading="loadingObj.linkInfoChart && loadingObj.linkInfoTable">
            <div>
                <div class="title">
                    <h5>星图指数</h5>
                    <i>{{linkInfo?.link_star_index?.value || ''}}</i>
                    <span :class="linkInfo?.link_star_index?.link_relative_ratio>0 ? 'colorRed':'colorGreen'">{{linkInfo?.link_star_index?.link_relative_ratio>0?'↑ ':'↓ '}}{{Math.abs(fmt(linkInfo?.link_star_index?.link_relative_ratio*100, {micrometer: true}))||'-'}}%</span>
                    <span style="margin-left:12px;color: #999;">行业内排名<span style="color:#333;font-weight: 600;margin-left: 5px;">{{handleRankPercent(linkInfo?.link_star_index?.rank_percent)}}</span></span>
                </div>
                <div class="radar_box">
                    <Radar :info="starPicRadar" ref="part1Chart"></Radar>
                </div>
            </div>
            <div class="list_box">
                <div class="list_head">
                    <span style="width:88px;text-align:center">指数名称</span><span style="width:88px;text-align:center">指数值</span><span style="width:88px;text-align:center">30天环比</span><span style="width:88px;text-align:center">行业均值</span><span style="width:88px;text-align:center">行业排名</span>
                </div>
                <div class="list_content">
                    <div class="list_item" v-for="(item,index) in exponentList" :key="index">
                        <span style="width:88px;text-align:center">
                            {{ item.name }}
                        </span>
                        <span style="width:88px;text-align:center">{{ item.value }}</span>
                        <span v-if="item.link_relative_ratio==0" style="width:88px;text-align:center">持平</span>
                        <span v-else style="width:88px;text-align:center" :class="item.link_relative_ratio>0 ? 'color-orange':'color-green'">{{item.link_relative_ratio>0?"+":''}}{{fmt(item.link_relative_ratio*100, {micrometer: true})}}%</span>
                        <span style="width:88px;text-align:center">{{ fmt(item.avg_value, {micrometer: true})}}</span>
                        <span style="width:88px;text-align:center">{{ item.rank<100? item.rank : handleRankPercent(item.rank_percent)}}</span>
                    </div>
                </div>
            </div>
        </div> -->
            <BusinessCapability :darenID="darenID" />
        </div>
    <!-- 内容表现  -->
    <div v-if="darenID" class="videoBoxPart block-wrap">
      <div class="videoHeader">
        <div class="leftTitle">内容表现</div>
        <div class="rightBtn" @click="scrollToTab2Video">
          <i class="el-icon-arrow-right"></i>
          查看更多
        </div>
      </div>
      <div class="videoContent" v-loading="loadingObj.getAuthorVideoRec">
        <ul v-if="videoItems?.length">
          <li v-for="(item,i) in videoItems" :key="i">
                <span :class="item.tagShow?'Toptag':'noToptag'">{{ item.tagName || '' }}</span>
                <div class="video" @click="e=>{videoClick(e,item)}" @mouseenter="e=>{videoMove(e,item)}" @mouseleave="e=>{videoOut(e,item)}">
                  <div class="videoWrap"></div>
                  <video muted :src="item.video_id" :vindex="i" :poster="item.img_id" preload="none"></video>
                </div>
                <p>{{item.title}}</p>
                <div class="tag">
                  <i></i>
                  <span>{{item.play}}</span>
                  <i></i>
                  <span>{{item.like}}</span>
                  <i></i>
                  <span>{{item.comment}}</span>
                </div>
            </li>
        </ul>
        <div class="noDataBox" v-else>
          <img src="../Cooperation/images/icon_none.png" alt="">
          <u class="noData">暂无数据</u>
        </div>
      </div>
    </div>
    <div v-if="alertShow.isShow" class="alertVideo" @click="closeClick">
      <div class="close" @click="closeClick"></div>
      <div class="videoCard" @click.stop>
        <div class="videoBox">
          <video autoplay controls loop :src="alertShow.src"></video>
        </div>
        <div class="videoInfo">
          <div class="videoInfoTop">
            <div class="photo"><img :src="darenInfo.avatar_uri" alt=""></div>
            <div class="name">
              <p> {{darenInfo.nick_name}}</p>
              <i>粉丝数</i><b>{{darenInfo.follower || '-'}}w</b>
            </div>
          </div>
          <div class="tag" v-for="(item,i) in darenInfo.tags_relation" :key="i">
            <span>{{i}}</span>
            <!-- <span>时尚是</span>
            <span>时尚</span> -->
          </div>
          <div class="hr"></div>
          <p> {{videoClickItem.title}} </p>
          <div class="other">
            <i></i><b>{{videoClickItem.play}}</b>
            <i></i><b>{{videoClickItem.like}}</b>
            <i></i><b>{{videoClickItem.comment}}</b>
          </div>
        </div>
        <div class="bottom">

          <span style="color:black;margin-left:0;margin-right: auto;font-size: 12px;">发布时间：{{videoClickItem.create_time}}</span>
          <a :href="videoClickItem.url" target="_blank">打开视频</a>
          <i v-clipboard:copy="videoClickItem.url" v-clipboard:success="onCopy">复制链接</i>
          <!-- <a href="javascript:void(0);" @click="copyUrl">复制链接</a> -->
        </div>

      </div>
    </div>
    <div v-if="darenID" class="card-panel user-connect-wrap block-wrap" v-loading="loadingObj.connectUserChartInfo || loadingObj.connectedUserRightInfo">
       <!-- 连接用户 -->
       <div class="bigTitleBox">
          <span class="bigTitle">连接用户</span>
          <el-dropdown trigger="click" @command="industryClick1">
                <span class="el-dropdown-link">
                  {{ "行业:"+industryData1.category_name }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item,index) in industry" :command="item" :key="index">{{item.category_name}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
       </div>

       <div class="content-container">
          <div class="flex-box">
              <!-- 漏斗图 -->
            <div class="user-connect-chart-wrap">
              <FunnelChart :chartInfo="connectUserChartInfo" ref="connectUserChartRef"></FunnelChart>
              <div class="label-group">
                  <div class="label-container">
                      <div class="label">
                          <span class="dot"></span>
                          了解
                      </div>
                      <div class="value">{{fmt(linkStruct?.link_struct?.['1']?.proportion*100, {micrometer: true})||'-'}}%</div>
                      <div class="value">{{changeW(linkStruct?.link_struct?.['1']?.value)}}w</div>
                  </div>
                  <div class="label-container">
                      <div class="label">
                          <span class="dot"></span>
                          兴趣
                      </div>
                      <div class="value">{{fmt(linkStruct?.link_struct?.['2']?.proportion*100, {micrometer: true})||'-'}}%</div>
                      <div class="value">{{changeW(linkStruct?.link_struct?.['2']?.value)}}w</div>
                  </div>
                  <div class="label-container">
                      <div class="label">
                          <span class="dot"></span>
                          喜欢
                      </div>
                      <div class="value">{{fmt(linkStruct?.link_struct?.['3']?.proportion*100, {micrometer: true})||'-'}}%</div>
                      <div class="value">{{changeW(linkStruct?.link_struct?.['3']?.value)}}w</div>
                  </div>
                  <div class="label-container">
                      <div class="label">
                          <span class="dot"></span>
                          追随
                      </div>
                      <div class="value">{{fmt(linkStruct?.link_struct?.['4']?.proportion*100, {micrometer: true})||'-'}}%</div>
                      <div class="value">{{changeW(linkStruct?.link_struct?.['4']?.value)}}w</div>
                  </div>
              </div>
            </div>
          </div>
          <div class="right">
              <div class="flex-box">
                  <div class="type-title">{{linkStruct?.author_link_type}}型达人</div>
                  <el-tooltip placement="top" content="该类达人,近30天的所有受众中，与达人进行深度互动达到【喜欢】层级的受众占比较高,这部分观众更容易被达人种草。">
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
              </div>
              <section>
                  <div class="section-title">总结</div>
                  <p> 月度连接总用户数 <strong> {{fmt(linkCard?.link_struct?.['5']?.value, {micrometer: true, fixedUnit: '万'})}}w，环比 {{fmt(linkCard?.link_struct?.['5']?.relative_ratio*100, {micrometer: true})}}% </strong></p>
                  <p> 位于行业内 <strong>{{handleRankPercent(linkStruct?.link_struct?.['5']?.rank_percent)}}</strong></p>
              </section>
              <section>
                  <div class="section-title">连接用户类型</div>
                  <!-- 年龄 type:2  性别 type:1  城市 type:32 -->
                  <!-- <p> 触达用户 <strong>{{ distributionsData1.image.join(',') }}，{{ distributionsData0.image.join(',') }}</strong></p>
                  <p> 集中 <strong>{{ distributionsData2.image.join(',') }}</strong></p>   -->
                  <p> 触达用户 <strong>{{ userAge}}，{{ gender }}</strong></p>
                  <p> 城市分布 <strong>{{ cityLevel}}</strong></p>
              </section>
          </div>
       </div>
    </div>
      <!-- <div class="part2">
          <div class="top">
            <h5>传播表现</h5>
            <i>时间范围: {{timeInfo.day_30}} ~ {{timeInfo.day_1}}</i>
            <el-radio-group class="tab clear" v-model="tab1Position" @change="tab1Click">
                <el-radio-button label="个人视频" name="个人视频">个人视频</el-radio-button>
                <el-radio-button label="观星视频" name="观星视频">观星视频</el-radio-button>
            </el-radio-group>
            <ul class="clear">
                <li>
                    <span>{{((!darenSpread.play_mid)||darenSpread.play_mid==='NaN')?'-':darenSpread.play_mid}}w</span>
                    <p>播放量中位数
                        <el-tooltip content="达人近30日新发布视频处于中位水平的播放情况" placement="bottom" effect="dark">
                            <i></i>
                        </el-tooltip>
                    </p>

                </li>
                <li>
                    <span>{{((!darenSpread.play_over_rate_proportion)||darenSpread.play_over_rate_proportion==='NaN')?'-':darenSpread.play_over_rate_proportion}}%</span>
                    <p>完播率
                        <el-tooltip content="达人近30日新发布视频被完整播放的概率" placement="bottom" effect="dark">
                            <i></i>
                        </el-tooltip>
                    </p>
                </li>
                <li>
                    <span>{{((!darenSpread.interact_rate_proportion)||darenSpread.interact_rate_proportion==='NaN')?'-':darenSpread.interact_rate_proportion}}%</span>
                    <p>互动率
                        <el-tooltip content="达人近30日新发布视频被点赞、评论、转发的概率" placement="bottom" effect="dark">
                            <i></i>
                        </el-tooltip>
                    </p>
                </li>
                <li>
                    <span>{{((!hotWord2.expected_play_num)||hotWord2.expected_play_num==='NaN')?'-':hotWord2.expected_play_num}}w</span>
                    <p>预期播放量
                        <el-tooltip content="基于达人发布满30天的数据推断得出，仅作参考" placement="bottom" effect="dark">
                            <i></i>
                        </el-tooltip>
                    </p>
                </li>
            </ul>
          </div>
          <div class="chart">
              <div class="chartItem">
                  <h5>近30天评论热词</h5>
                  <div class="hotword">
                      <span v-for="(item,i) in hotWord" :key="i">{{item.comment_token}}</span>
                  </div>
              </div>
              <div class="chartItem">
                  <BarChart :barChartInfo="hotwordEchartData" ref="part2Chart"></BarChart>
              </div>
          </div>
      </div> -->
      <!-- <div class="part3 chart">
            <div class="chartItem">
                <h5>性价比表现</h5>
                <el-radio-group class="tab clear" v-model="tab2Position" @change="tab2Click">
                    <el-radio-button label="1-20s视频">1-20s视频</el-radio-button>
                    <el-radio-button label="20-60s视频">20-60s视频</el-radio-button>
                    <el-radio-button label="60s以上视频">60s以上视频</el-radio-button>
                </el-radio-group>
                <div class="expect">
                    <i>{{(expectData.cpm&&expectData.cpm!=="NaN")?(expectData.cpm/100).toFixed(1):'-'}}</i>
                    <p>预期CPM
                        <el-tooltip content="" placement="bottom" effect="dark">
                            <div slot="content">基于账号预计播放量与当前报价计算的千次播放量费用预<br/>估，仅作参考</div>
                            <i></i>
                        </el-tooltip>
                    </p>
                </div>
                <div class="expect">
                    <i>{{(expectData.cpe&&expectData.cpe!=="NaN")?(expectData.cpe/100).toFixed(1):'-'}}</i>
                    <p>预期CPE
                        <el-tooltip content="达人近30日新发布视频被完整播放的概率" placement="bottom" effect="dark">
                            <div slot="content">基于达人预播放量、近期视频互动率、当前报价计算的<br/>单次点赞/评论/转发费用预估</div>
                            <i></i>
                        </el-tooltip>
                    </p>
                </div>
            </div>
            <div class="chartItem task">
                <h5>任务表现</h5>
                <div class="clear">
                <div class="expect">
                    <i>{{darenCoope.order_in_process_cnt}}</i>
                    <p>进行中的任务数
                        <el-tooltip content="达人当前正在进行中的任务数量" placement="bottom" effect="dark">
                            <i></i>
                        </el-tooltip>
                    </p>
                </div>
                <div class="expect">
                    <i>{{darenCoope.order_finish_cnt}}</i>
                    <p>完成任务数</p>
                </div>
                <div class="expect">
                    <i v-if="darenCoope.rating">{{darenCoope.rating.comprehensive_rating}}</i>
                    <p>任务评分</p>
                </div>
                </div>
                <div class="bottom clear" v-if="darenCoope.rating">
                    <span>内容质量{{darenCoope.rating.content_rating}}</span><span>合作态度{{darenCoope.rating.service_rating}}</span><span>数据效果{{darenCoope.rating.data_rating}}</span>
                </div>
            </div>
      </div> -->
      <!-- <div class="part7">
        <div class="top">
            <h5>达人历史成交趋势</h5>
            <i>数据范围: 近期在我司平台成交的一口价订单</i>
        </div>
        <div class="noData" v-if="part7Chart1Data.data.length===0">
            <img src="../images/noData3.png" alt="">
            <span>暂无数据</span>
        </div>
        <LineChart v-if="part7Chart1Data.data.length!==0" :lineChartInfo="part7Chart1Data" ref="part7Chart1"></LineChart>
      </div> -->
      <!-- <div class="part4">
          <div class="top">
            <h5>涨粉表现</h5>
            <i>时间范围: {{timeInfo.day_30}} ~ {{timeInfo.day_1}}</i>
            <el-radio-group class="tab clear" v-model="tab4Position" @change="tab4Click">
                <el-radio-button label="总量">总量</el-radio-button>
                <el-radio-button label="增量">增量</el-radio-button>
            </el-radio-group>
          </div> -->
          <!-- 没数据移除 -->
          <!-- <div class="addFansData" v-if="false">
                <div class="expect">
                    <i>{{part4Data.addNum?part4Data.addNum:'-'}}</i>
                    <i>{{part4Data.addNum?parseInt(part4Data.addNum).toFixed(1):'-'}}</i>
                    <p>粉丝增长量</p>
                </div>
                <div class="expect">
                    <i>{{part4Data.addDeg?parseInt(part4Data.addDeg).toFixed(1):'-'}}%</i>
                    <p>粉丝增长幅度</p>
                </div>
          </div>
            <LineChart :lineChartInfo="addFansData" ref="part4Chart"></LineChart>
      </div> -->
      <!-- 没数据移除 -->
      <div class="part5 block-wrap" v-if="false">
          <div class="top">
            <h5>种草表现</h5>
            <i>时间范围: {{timeInfo.day_30}} ~ {{timeInfo.day_1}}</i>
          </div>
          <div class="chart">
              <div class="chartItem" v-if="!commerceIsShow">
                 <div class="title">带货品类</div>
                 <div class="noData">
                     <img src="../images/download.png" alt="">
                     <span>暂无数据</span>
                 </div>
              </div>
              <div class="chartItem" v-if="commerceIsShow">
                  <!-- <RingChart :ringChartInfo="commerceData" ref="outlineChart5"></RingChart> -->
              </div>
              <div class="chartItem">
                <div class="title">带货数据概览</div>
                <div class="expect">
                    <i>{{darenGoods.ecom_video_num?darenGoods.ecom_video_num:'-'}}</i>
                    <p>带货视频数</p>
                </div>
                <div class="expect">
                    <i>{{darenGoods.ecom_video_vv_medium?darenGoods.ecom_video_vv_medium:'-'}}</i>
                    <p>播放量中位数</p>
                </div>
                <div class="expect">
                    <i>￥{{darenGoods.ecom_video_main_price_range?darenGoods.ecom_video_main_price_range:'-'}}</i>
                    <p>带货客单价区间</p>
                </div>
                <div class="expect">
                    <i>￥{{darenGoods.ecom_video_avg_sale_amount_range?darenGoods.ecom_video_avg_sale_amount_range:'-'}}</i>
                    <p>平均销售额区间</p>
                </div>

              </div>
          </div>
      </div>
      <!-- <div class="part6" v-loading="loadingObj.similarityTalent">
          <div class="bottemList">
            <div class="title">
                <div class="titleLeft">与 <i>{{darenInfo.nick_name || ''}}</i> 相似的达人</div>
                <div style="display:none;" class="titleRight"><i class="reflesh"></i>刷新一下</div>
            </div>
            <ul class="sameList">
                <li v-for="(item,i) in sameDaren" :key="i">
                    <a :toHref="item.author_id" href="javascript:void(0);" @click="sameListClick">
                        <div class="top">
                            <div class="nameWrap">
                                <span>{{item.nick_name}}</span>
                                <div></div>
                                <i v-for="(u,v) in item.tags_content" :key="v">{{u}}</i>
                            </div>
                            <div class="imgWrap">
                                <img :src="item.avatar_uri" alt="">
                            </div>
                        </div>
                        <div class="center">
                            <div class="centerItem">
                                <span>{{(item.follower/10000).toFixed(1)}}w</span>
                                <p>粉丝数</p>
                            </div>
                            <div class="centerItem">
                                <span>{{item.expected_cpm}}</span>
                                <p>预期CPM</p>
                            </div>
                            <div class="centerItem">
                                <span>{{(item.author_score/10000).toFixed(1)}}</span>
                                <p>星图指数</p>
                            </div>
                        </div>
                        <div class="tag">
                            <span v-for="(x,b) in item.recommend_types" :key="b">{{x}}</span>
                        </div>
                        <div class="hr"></div>
                        <div class="bottem">
                            <span class="price">￥{{item.min_price}}</span>
                            <div class="other">
                                <i></i>详情
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
          </div>
      </div> -->

  </div>
</template>

<script>
import Radar from '../../../components/newEchart/Radar.vue';
import FunnelChart from '../../../components/Echart/FunnelChart.vue';
import CooperationDetailTable from '@/pages/daren/Cooperation/CooperationDetailTable.vue';
import BusinessCapability from './BusinessCapability.vue';
export default {
  name: "Outline",
//   props:['darenName','authorDrinfo'],
  props:{
    //  'darenName':{
    //     type: String
    //  },
     'darenInfo':{
        type: Object,
        default: () => ({})
     },
     'authorDrinfo':{
        type: Object
     },
     'supplierList':{
        type: Array,
        default:()=>([])
     },
     hideSupplierTable: {
        type: Boolean,
        default: false
     }
  },
  data(){
    return {
      linkStruct:{
        link_struct:{'1':{},'2': {},'3': {},'4': {}}
      },
      linkCard:{
        link_struct:{'1':{},'2': {},'3': {},'4': {},'5':{}}
      },
      distributionsData0:{},
      distributionsData1:{},
      distributionsData2:{},
      gender:{},
      userAge:{},
      cityLevel:{},
        // pageSameDarenRec:{},
        pageDarenCategory:{},
        pageDarenGoodsIndex30:{},
        pageDarenSpread22:{},
        pageDarenSpread12:{},
        pageDarenCoope:{},
        // pageGetHotWord2:{},
        pageGetHotWord:{},
        pagelinkInfo:{},
        // pageDarenInfo:{},
        //tab4Click是否是初始化
        isInitialize:true,
      darenID:'',
        //时间
      timeInfo:{
          day_1:'',
          day_7:'',
          day_30:'',
          day_90:''
      },
      alertShow:{
        isShow:false,
        src:''
      },
      //相似达人
      sameDaren:{},
      // 达人指数数据
      linkInfo:{},
      //大人热词
      hotWord:{},
    //   hotWord2:{},
      videoList:{},
      //达人播放数据
    //   darenInfo:{},
      // 达人传播指数
      darenSpread:{},
      // 同类达人指数分析
      score_detail:{},
      // 达人任务
      darenCoope:{},
      // 带货平类
      darenCategory:{},
      //达人带货指数
      darenGoods:{},
      //预期数据
      expectData:{
          cpm:0,
          cpe:0
      },
      darenFans:{},
      tab1Position: '个人视频',
      tab2Position: '1-20s视频',
      tab4Position: '总量',
      guanxingIndexData:{//观星指数趋势图
        nodeId:'guanxingIndex',//节点
          data: [],//数据
        //   smooth:false,//平滑
          xAxisData:[],
        //   min:50, //y轴的最小值
        //   max:75, //y轴最大值
        //   interval:5, //值之间的间隔
        //   yAxisName: '',
        //   tooltipName:'',
        //   unit:''
      },
      hotwordEchartData:{//近30天评论热词
        nodeId:'hotwordEchart',//节点
        data: [],//数据
        color:["#ff5c00","#40a0fc"],
        xAxisData:[],
        min:0, //y轴的最小值
        max:500, //y轴最大值
        interval:100, //值之间的间隔
        yAxisName: '评论数',
        tooltipName:'评论数',
        unit:''//单位
      },
      addFansData:{//涨粉表现
          nodeId:'addFans',//节点
          data: [],//数据
        //   smooth:true,//平滑
          xAxisData:[],
        //   min:35, //y轴的最小值
        //   max:50, //y轴最大值
        //   interval:5, //值之间的间隔
        //   yAxisName: '粉丝人数',
        //   tooltipName:'粉丝总量',
          unit:''
      },
      starPicData:{//星图指数
          nodeId:'starPic',//节点
          data: [],//数据
          max:[{text: '传播表现',value:'234', max: 100},{text: '涨粉表现 23',value:'234', max: 100},{text: '性价比表现 12',value:'234', max: 100},{text: '任务表现 123',value:'234', max: 100},{text: '种草表现 34',value:'234', max: 100}],
          data1:[],
          data2:[],
          formatter:function(params){
            return ('<div style="text-align:center;padding:0 8px;">虚线表示行业最低标准</div>')
          }
      },
      starPicRadar:{},
      part7Chart1Data:{//观星指数趋势图
        nodeId:'part7Chart1Node',//节点
        data: [],//数据
        //   smooth:false,//平滑
        xAxisData:[],
        //   min:50, //y轴的最小值
        //   max:75, //y轴最大值
        //   interval:5, //值之间的间隔
        yAxisName: '价格',
        //   tooltipName:'',
        unit:'',
        unit2:'￥',
      },

      part4Data:{
          addNum:"-",
          addDeg:"-",
      },
      flagPart:{
          flag1:false,
          flag2:true,
          flag3:true,
          flag4:true,
          flag5:true,
          flag6:true,
      },
    //   种草表现品类
      // commerceData:{
      //     //设备分布
      //     nodeId: "commerceDataNode", //节点
      //     data: [{
      //         value: 18.5,
      //         name: "华为"
      //       }
      //     ], //数据
      //     color: ["#2074ff",
      //       "#38a1ff",
      //       "#77bfff",
      //       "#a7d6ff",
      //       "#d0e9ff",
      //       "#def0ff",],
      //     xAxisData: ["0-18"],
      //     min: 0, //y轴的最小值
      //     max: 60, //y轴最大值
      //     interval: 20, //值之间的间隔
      //     yAxisName: "占比",
      //     tooltipName: "占比",
      //     unit: "%",
      //     guideline: true, //引导线
      // },
      commerceIsShow:true,
      industry:[],//行业信息
      industryData:{
            category_id:0,
            category_name:'不限'
        },
      industryData1:{
            category_id:0,
            category_name:'不限'
        },
      exponentList:[],
      /* videoList修改为videoItems:视频作品内容,原名冲突 */
      videoItems:[],
      trendChartInfo:{
        nodeId:"trendChart",
        //这个data固定长度是2
        data:[[],[]]
      },
      currentActiveTabIndex: 0,
      connectUserChartInfo:{
        nodeId:"connectUserChart",
        data:[[],[]]
      },
      showTopTag:true,
      videoClickItem:{},
      loadingObj: {
        linkInfoChart: false, //商业能力图表
        linkInfoTable: false, //商业能力表格
        connectUserChartInfo: false, //连接用户左边的数据
        connectedUserRightInfo: false, //连接用户右边的数据
        similarityTalent: false, //相似达人
        getAuthorVideoRec: false
      },
      supplierGridOptions: {
            border: 'inner',
            maxHeight: '380',
            columns: [
                { field: 'product_name', title: '产品类型' },
                { field: 'account_type', title: '账号类型' },
                { field: 'suppliers_name', title: '供应商', slots: { default:'suppliers_name' } },
                { field: 'devidedrate', title: '媒体侧自然返点%' },
            ],
        },
      pjList:[],
      isCooperationExpand: false,
      isSupplierListExpand: true,
    }
  },
  computed:{

  },
  components:{
   Radar,
   FunnelChart,
   CooperationDetailTable,
   BusinessCapability, //商业能力
  },
  watch:{
        authorDrinfo:{
            deep: true,
            handler(val, oldval) {
                window.sessionStorage.setItem('getAuthorDrinfo',JSON.stringify(val))
                this.initPart7Chart1Data(JSON.parse(window.sessionStorage.getItem('getAuthorDrinfo')))
            }
        },
        "industryData.category_id":{
            handler(val){
                this.getLinkInfo()
                this.getLinkDistribution()
            },
            deep:true
        },
        "industryData1.category_id":{
            handler(val){
                this.getLinkStruct()
            },
            deep:true
        },
        darenInfo:{
            handler(){
                this.create1()
            },
            deep:true,
            immediate:true
        }
  },
  created(){

    this.darenID = this.$route.query.id
    this.getLinkInfo()
    this.getDarenItems()
    this.getAuthorIndustry()
    this.getLinkStruct()
    this.getLinkDistribution()
    this.getPjTableData()

    //   获取达人热评词
    // if(window.sessionStorage.getItem('getHotWord')){
    //     this.create3()
    // }else{
    //     this.$api.getData.getHotWord('/'+this.darenID).then((res) => {
    //         window.sessionStorage.setItem('getHotWord',JSON.stringify(res));
    //         this.create3()
    //         this.$refs?.part2Chart?.barChart(this.hotwordEchartData)
    //     })
    // }

    //   获取达人热评词2
    // if(window.sessionStorage.getItem('getHotWord2')){
    //     this.create4()
    // }else{
    //     this.$api.getData.getHotWord2('/'+this.darenID).then((res) => {
    //         window.sessionStorage.setItem('getHotWord2',JSON.stringify(res));
    //         this.create4()
    //     })
    // }

    //   获取达人传播指数
    // this.tab1Click(this.tab1Position)

    //   获取达人任务数据
    // if(window.sessionStorage.getItem('getDarenCoope')){
    //     this.pageDarenCoope= JSON.parse(window.sessionStorage.getItem('getDarenCoope'))?.data?.data
    //     this.darenCoope = this.pageDarenCoope
    // }else{
    //     this.$api.getData.getDarenCoope('/'+this.darenID).then((res) => {
    //         window.sessionStorage.setItem('getDarenCoope',JSON.stringify(res));
    //         this.darenCoope = res.data.data
    //     })
    // }

    //  获取达人粉丝数据
    if(window.sessionStorage.getItem('getDarenCoope')){
        this.pageDarenFans= JSON.parse(window.sessionStorage.getItem('getDarenFans'))?.data?.data
        this.darenFans = this.pageDarenFans
        this.tab4Click('总量')
    }else{
        // this.$api.getData.getDarenFans('/'+this.darenID).then((res) => {
        //     window.sessionStorage.setItem('getDarenFans',JSON.stringify(res));
        //     this.darenFans = res.data.data
        //     this.tab4Click('总量')
        //     this.$refs?.part4Chart?.lineChart(this.addFansData)
        // })
    }

    //  获取达人带货指数
    // if(window.sessionStorage.getItem('getDarenCoope')){
    //     this.pageDarenGoodsIndex30= JSON.parse(window.sessionStorage.getItem('getDarenGoodsIndex30'))?.data?.data
    //     if(this.pageDarenGoodsIndex30.video_data){
    //         this.darenGoods = this.pageDarenGoodsIndex30.video_data
    //         if(this.darenGoods.ecom_video_vv_medium>=10000){
    //             this.darenGoods.ecom_video_vv_medium=this.changeW(this.darenGoods.ecom_video_vv_medium)+'w'
    //         }
    //     }
    // }else{
    //     this.$api.getData.getDarenGoodsIndex('/'+this.darenID,'day_count=30').then((res) => {
    //         window.sessionStorage.setItem('getDarenGoodsIndex30',JSON.stringify(res));
    //         if(res.data.data.video_data){
    //             this.darenGoods = res.data.data.video_data
    //             if(this.darenGoods.ecom_video_vv_medium>=10000){
    //                 this.darenGoods.ecom_video_vv_medium=this.changeW(this.darenGoods.ecom_video_vv_medium)+'w'
    //             }
    //         }
    //     })
    // }
    //  获取达人带货品类
 /*    if(window.sessionStorage.getItem('getDarenCoope')){
        this.pageDarenCategory= JSON.parse(window.sessionStorage.getItem('getDarenCategory')).data.data
        this.create9()
    }else{
        this.$api.getData.getDarenCategory('/'+this.darenID).then((res) => {
            window.sessionStorage.setItem('getDarenCategory',JSON.stringify(res));
            this.pageDarenCategory= JSON.parse(window.sessionStorage.getItem('getDarenCategory')).data.data
            this.create9()
            this.$refs.outlineChart5.ringChart(this.commerceData)
        })
    } */
    //  获取相似达人推荐
    // if(window.sessionStorage.getItem('getDarenCoope')){
    //     this.pageSameDarenRec= JSON.parse(window.sessionStorage.getItem('getSameDarenRec')).data.data
    //     this.create10()
    // }else{
    //     this.loadingObj.similarityTalent = true
    //     this.$api.getData.getSameDarenRec('/'+this.darenID, false).then((res) => {
    //         window.sessionStorage.setItem('getSameDarenRec',JSON.stringify(res));
    //         this.pageSameDarenRec= JSON.parse(window.sessionStorage.getItem('getSameDarenRec')).data.data
    //         this.create10()
    //     })
    // }



  },
  methods:{
    isAfterToday(targetTime) {
          // 将目标时间字符串转换为 Date 对象
          const targetDate = new Date(targetTime.replace(/-/g, '/'));
          // 获取当前日期并设置时间为 00:00:00
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          // 比较目标时间是否在今天及之后
          let isFlag = targetDate >= today;
          return isFlag;
        },
    getDaysRemaining(dateStr) {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // 将时间设置为当天的零点，避免时间影响

            const targetDate = new Date(dateStr);
            if (isNaN(targetDate.getTime())) {
                console.error('输入的日期格式不正确，请使用 "YYYY-MM-DD" 格式。');
                return null;
            }

            const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
            const diffTime = targetDate - today;
            return Math.round(diffTime / oneDay);
        },
    async getPjTableData() {
        if(!this.$route.query.mid){
          return
        }
        let params = {
            mid: this.$route.query.mid,
        };
        const res = await this.$axios.post(`/api.php?m=detail|api|gx&a=getCompetitive`, params)
        console.log('res :>> ', res);
        this.pjList = res.filter(x => {
              return this.isAfterToday(x.end_time)
            }) || [];
    },
       // 转换接口参数
    convertActive(){
      switch(this.currentActiveTabIndex){
        case 0: return 5;
        case 1: return 1;
        case 2: return 2;
        case 3: return 3;
        case 4: return 4;
      }
    },
    handleRankPercent(rankPercent){
        if(!rankPercent){
            return "-%"
        }
        let newRankPercent = this.fmt(rankPercent*100, {micrometer: true})
        let finalResult = ""
        if(newRankPercent>0 && newRankPercent<0.5){
            finalResult = "前0.5%"
        }else if(newRankPercent>0.5 && newRankPercent<3){
            finalResult = "前3%"
        }else if(newRankPercent>3 && newRankPercent<10){
            finalResult = "前10%"
        }else if(newRankPercent>10 && newRankPercent<20){
            finalResult = "前20%"
        }else if(newRankPercent>20 && newRankPercent<50){
            finalResult = "前50%"
        }else if(newRankPercent>50 && newRankPercent<70){
            finalResult = "低于50%"
        }else if(newRankPercent>70 && newRankPercent<100 || newRankPercent < 0){
            finalResult = "低于70%"
        }
        return finalResult

    },
    getLinkInfo(){
        if (!this.darenID) {
            return
        }
        this.loadingObj.linkInfoTable = true
        this.loadingObj.linkInfoChart = true
        this.$api.getData.getLinkInfo(`/${this.darenID}?platform_channel=1&industy_tag=${this.industryData.category_id}`).then((res) => {
            window.sessionStorage.setItem('getLinkInfo',JSON.stringify(res));
            let data = res.data.data
            this.exponentList=[]
            let arr = ["传播指数","种草指数","转化指教","性价比指数","合作指数",]
            arr?.forEach(x=>{
                if(x=="传播指数"){
                    this.exponentList.push({name:x,...data.link_spread_index})
                }
                if(x=="种草指数"){
                    this.exponentList.push({name:x,...data.link_shopping_index})
                }
                if(x=="转化指教"){
                    this.exponentList.push({name:x,...data.link_convert_index})
                }
                if(x=="性价比指数"){
                    this.exponentList.push({name:x,...data.cp_index})
                }
                if(x=="合作指数"){
                    this.exponentList.push({name:x,...data.cooperate_index})
                }
            })
            this.loadingObj.linkInfoTable = false
            this.create2();
            this.loadingObj.linkInfoChart = false
            // this.$refs.part1Chart.radarChart(this.starPicData)
            // this.$refs.part1Chart2.lineChart(this.guanxingIndexData)
        })
    },
    // getLinkStruct获取 连接用户分布分 1-了解 2-兴趣 3-喜欢 4-追随 5-连接用户数...
    async getLinkStruct(){
        if (!this.darenID) {
            return
        }
        this.loadingObj.connectUserChartInfo = true
        this.$api.getData.getLinkStruct(`/${this.darenID}?platform_channel=1&industy_tag=${this.industryData1.category_id}`, false).then((res) =>{
            this.linkStruct = res.data.data

            this.updateConnectUserChart()
        })
        await this.getLinkCard()
        this.loadingObj.connectUserChartInfo = false
    },
      // getLinkCard获取 连接用户环比
    async getLinkCard(){
        if (!this.darenID) {
            return
        }
      await this.$api.getData.getLinkCard(`/${this.darenID}?platform_channel=1&industry_id=${this.industryData1.category_id}`, false).then((res) => {
          this.linkCard = res.data.data

      })
    },
    //连接用户画像
    getLinkDistribution(){
        if (!this.darenID) {
            return
        }
      this.$api.getData.getLinkDistribution(`/${this.darenID}?platform_channel=1&link_type=${this.convertActive()}`)
      .then((res) => {
          this.linkDistributionData = res.data.data
          this.distributionsData0 = this.linkDistributionData?.distributions.find(d=>d.type==1);
          this.distributionsData1 = this.linkDistributionData?.distributions.find(d=>d.type==2);
          this.distributionsData2 = this.linkDistributionData?.distributions.find(d=>d.type==32);
          this.gender=this.distributionsData0?.image.join(',')
          this.userAge=this.distributionsData1?.image.join(',')
          this.cityLevel=this.distributionsData2?.image.join(',')
      })

    },

    // 内容表现视频
    async getDarenItems(){
        if (!this.darenID) {
            return
        }
        this.loadingObj.getAuthorVideoRec = true
        const res = await this.$api.getData.getAuthorVideoRec(`/${this.darenID}?platform_channel=1`)
        let data = res.data.data
        let videoItems = []
        let videoList = []
        let arr = {newest_video:'最新视频',personal_hot_video:'个人爆文',order_hot_video:'商单爆文',masterpiece_videos:'代表视频'}
        Object.keys(arr)?.forEach(key=>{
        if(data?.[key]){
            if(key == "masterpiece_videos"){
                if(data?.[key]?.length>0){
                    videoList.push({...data[key][0],tagName:arr[key],tagShow:true})
                }
            }else{
                videoList.push({...data[key],tagName:arr[key],tagShow:true})
            }
        }
        })

        for (const item of videoList) {
            let v={}
            // v:视频内容
            v.title=item.title
            v.comment=item?.stats?.comment_cnt
            v.play=item?.stats?.watch_cnt
            v.like=item?.stats?.favorite_cnt
            v.url=item.url
            v.video_id='https://aweme.snssdk.com/aweme/v1/playwm/?video_id='+item.video_id+'&ratio=720p&line=0'
            const res = await this.$api.getData.getAuthorVideoInfo(`?video_id=${item.video_id}`)
            let videoInfo = res?.data?.data || {}

            v.img_id = videoInfo.cover
            v.tagName = item.tagName
            v.tagShow = item.tagShow
            v.create_time = this.dayjs(item.create_time * 1000).format('YYYY-MM-DD HH:mm:ss')
            if(v.like>=10000){
                v.like=(v.like/10000).toFixed(1)+'w'
            }
            if(v.play>=10000){
                v.play=(v.play/10000).toFixed(1)+'w'
            }
            if(v.comment>=10000){
                v.comment=(v.comment/10000).toFixed(1)+'w'
            }
            videoItems.push(v)
        }

        this.videoItems = videoItems
        this.loadingObj.getAuthorVideoRec = false

    },
    //获取行业信息
    async getAuthorIndustry(){
        await this.$api.getData.getAuthorIndustry().then((res) => {
            let data = res?.data?.data?.industry_categories

            this.industry = data?.map(x=>{
                return {category_id:x.category_id,category_name:x.category_name}
            })
            this.industry?.unshift({
                category_id:0,
                category_name:'不限'
            })
        })
    },

    industryClick(val){
      this.industryData = val
    },
    industryClick1(val){
      this.industryData1 = val
    },
    initPart7Chart1Data(val){
        let xAxisData =[]
        let data = []
        let part7Chart1Data={//观星指数趋势图
            nodeId:'part7Chart1Node',//节点
            data: [],//数据
            xAxisData:[],
            yAxisName: '价格',
            unit:'',
            unit2:'￥',
        }
        val.list&&val?.list?.map(item=>{
            xAxisData.push(item.publishtime)
            data.push(item.contractprice-0)
        })
        part7Chart1Data.xAxisData = xAxisData
        part7Chart1Data.data = data
        this.part7Chart1Data = part7Chart1Data
        setTimeout(() => {
            if(data.length>0){
                this.$refs?.part7Chart1?.lineChart(this.part7Chart1Data)
            }
        })
    },
    sameListClick(e){
        let inSalesGroup=window.sessionStorage.getItem('inSalesGroup')
        let name=window.sessionStorage.getItem('name')
        window.sessionStorage.clear()
        window.sessionStorage.setItem('inSalesGroup',inSalesGroup)
        window.sessionStorage.setItem('name',name)
        let routeData = this.$router.resolve({
            path: '/daren',
          query: {
              id: e.currentTarget.getAttribute("tohref")
          }
        })
        window.open(routeData.href, "_blank");
    },
    changeW(num){
       return (num/10000).toFixed(1)
    },
    tab1Click(tab) {
        if (!this.darenID) {
            return
        }
        if(tab==='个人视频'){
            if(window.sessionStorage.getItem('getDarenSpread12')){
                this.pageDarenSpread12= JSON.parse(window.sessionStorage.getItem('getDarenSpread12')).data.data
                let getData = this.pageDarenSpread12
                    if(getData.play_mid>=1000){
                        getData.play_mid = this.changeW(getData.play_mid)
                    }
                    getData.play_over_rate_proportion = (getData.play_over_rate.value/100).toFixed(2)
                    getData.interact_rate_proportion = (getData.interact_rate.value/100).toFixed(2)
                    this.darenSpread = getData
                    this.expectData.cpm=this.darenSpread.expect_cpm.cpm_1_20
                    this.expectData.cpe=this.darenSpread.expect_cpe.cpe_1_20
            }else{
                this.$api.getData.getDarenSpread('/'+this.darenID,'type=1&range=2').then((res) => {
                    window.sessionStorage.setItem('getDarenSpread12',JSON.stringify(res));
                    let getData = res.data.data
                    if(getData.play_mid>=1000){
                        getData.play_mid = this.changeW(getData.play_mid)
                    }
                    getData.play_over_rate_proportion = (getData.play_over_rate.value/100).toFixed(2)
                    getData.interact_rate_proportion = (getData.interact_rate.value/100).toFixed(2)
                    this.darenSpread = getData
                    this.expectData.cpm=this.darenSpread.expect_cpm.cpm_1_20
                    this.expectData.cpe=this.darenSpread.expect_cpe.cpe_1_20
                })
            }
        }else if(tab==='观星视频'){
            if(window.sessionStorage.getItem('getDarenSpread22')){
                this.pageDarenSpread22= JSON.parse(window.sessionStorage.getItem('getDarenSpread22')).data.data
                let getData = this.pageDarenSpread22
                    if(getData.play_mid>=1000){
                        getData.play_mid = this.changeW(getData.play_mid)
                    }
                    getData.play_over_rate_proportion = (getData.play_over_rate.value/100).toFixed(2)
                    getData.interact_rate_proportion = (getData.interact_rate.value/100).toFixed(2)
                    this.darenSpread = getData
                    this.expectData.cpm=this.darenSpread.expect_cpm.cpm_1_20
                    this.expectData.cpe=this.darenSpread.expect_cpe.cpe_1_20
            }else{
                this.$api.getData.getDarenSpread('/'+this.darenID,'type=2&range=2').then((res) => {
                    window.sessionStorage.setItem('getDarenSpread22',JSON.stringify(res));
                    let getData = res.data.data
                    if(getData.play_mid>=1000){
                        getData.play_mid = this.changeW(getData.play_mid)
                    }
                    getData.play_over_rate_proportion = (getData.play_over_rate.value/100).toFixed(2)
                    getData.interact_rate_proportion = (getData.interact_rate.value/100).toFixed(2)
                    this.darenSpread = getData
                    this.expectData.cpm=this.darenSpread.expect_cpm.cpm_1_20
                    this.expectData.cpe=this.darenSpread.expect_cpe.cpe_1_20
                })
            }
        }
    },
    // tab2Click(tab) {
    //     if(tab==='1-20s视频'){
    //         this.expectData.cpe=this.darenSpread.expect_cpe.cpe_1_20
    //         this.expectData.cpm=this.darenSpread.expect_cpm.cpm_1_20
    //     }else if(tab==='20-60s视频'){
    //         this.expectData.cpe=this.darenSpread.expect_cpe.cpe_21_60
    //         this.expectData.cpm=this.darenSpread.expect_cpm.cpm_21_60
    //     }else if(tab==='60s以上视频'){
    //         this.expectData.cpe=this.darenSpread.expect_cpe.cpe_60
    //         this.expectData.cpm=this.darenSpread.expect_cpm.cpm_60
    //     }
    // },
    tab4Click(tab) {
        let getData = this.darenFans
        let addFansData={//涨粉表现
          nodeId:'addFans',//节点
          data: [],//数据
          smooth:true,//平滑
          xAxisData:[],
          min:0, //y轴的最小值
          max:0, //y轴最大值
          interval:50, //值之间的间隔
          yAxisName: '粉丝人数',
          tooltipName:'粉丝总量',
          unit:'',
          xInterval:1,
        }
        this.part4Data.addNum=getData?.fans_growth
        this.part4Data.addDeg=(getData?.fans_growth_rate.toFixed(4))*100
        if(tab==='总量'){
            getData?.daily?.forEach(function(item,i){
                let splitTime = item.date
                let time = splitTime.split('-')
                addFansData.xAxisData.push(time[1]+'-'+time[2])

                addFansData.data.push(item.fans_cnt)
            })
            addFansData.unit=''
            // addFansData.max =(parseInt(Math.max.apply(null,addFansData.data)/10)+1)*10
            // addFansData.min =(parseInt(Math.min.apply(null,addFansData.data)/10)-1)*10
            // addFansData.interval = (addFansData.max - addFansData.min)/4
            this.addFansData =addFansData
        }else if(tab==='增量'){
            getData?.delta?.forEach(function(item,i){
                let splitTime = item.date
                let time = splitTime.split('-')
                addFansData.xAxisData.push(time[1]+'-'+time[2])
                addFansData.data.push(parseInt(item.fans_cnt))
            })
            addFansData.unit=''
            addFansData.yAxisName='增长人数'
            // addFansData.max =(parseInt(Math.max.apply(null,addFansData.data)/10)+1)*10
            // addFansData.min =(parseInt(Math.min.apply(null,addFansData.data)/10)-1)*10
            // addFansData.interval = (addFansData.max - addFansData.min)/4
            this.addFansData =addFansData
        }
        if(!this.isInitialize){
            this.$refs?.part4Chart?.lineChart(this.addFansData)
        }
        this.isInitialize=false
    },
    create1(){
        //   获取达人基础信息 时间
        this.timeInfo.day_1 = this.darenInfo.day_1
        this.timeInfo.day_7 = this.darenInfo.day_7
        this.timeInfo.day_30 = this.darenInfo.day_30
        this.timeInfo.day_90 = this.darenInfo.day_90
        // this.pageDarenInfo= JSON.parse(window.sessionStorage.getItem('getDarenInfo')).data.data
        // this.darenInfo = this.pageDarenInfo
        // this.timeInfo.day_1 = this.pageDarenInfo.day_1
        // this.timeInfo.day_7 = this.pageDarenInfo.day_7
        // this.timeInfo.day_30 = this.pageDarenInfo.day_30
        // this.timeInfo.day_90 = this.pageDarenInfo.day_90
    },
    create2(){
        //   获取达人指数数据
        this.pagelinkInfo= JSON.parse(window.sessionStorage.getItem('getLinkInfo')).data.data;
        this.linkInfo = this.pagelinkInfo
        this.linkInfo.link_spread_index.value = this.pagelinkInfo.link_spread_index.value
        this.linkInfo.link_shopping_index.value = this.pagelinkInfo.link_shopping_index.value
        this.linkInfo.link_convert_index.value = this.pagelinkInfo.link_convert_index.value
        this.linkInfo.cp_index.value = this.pagelinkInfo.cp_index.value
        this.linkInfo.cooperate_index.value = this.pagelinkInfo.cooperate_index.value

        this.linkInfo.link_spread_index.avg_value = this.pagelinkInfo.link_spread_index.avg_value
        this.linkInfo.link_shopping_index.avg_value = this.pagelinkInfo.link_shopping_index.avg_value
        this.linkInfo.link_convert_index.avg_value = this.pagelinkInfo.link_convert_index.avg_value
        this.linkInfo.cp_index.avg_value = this.pagelinkInfo.cp_index.avg_value
        this.linkInfo.cooperate_index.avg_value = this.pagelinkInfo.cooperate_index.avg_value
        // this.linkInfo.top_score = this.changeW(this.pagelinkInfo.top_score)
        // this.linkInfo.link_spread_index.value  = this.changeW(this.pagelinkInfo.link_spread_index.value)
        // this.linkInfo.link_shopping_index.value  = this.changeW(this.pagelinkInfo.link_shopping_index.value)
        // this.linkInfo.link_convert_index.value  = this.changeW(this.pagelinkInfo.link_convert_index.value)
        // this.linkInfo.cp_index.value  = this.changeW(this.pagelinkInfo.cp_index.value)
        // this.linkInfo.cooperate_index.value  = this.changeW(this.pagelinkInfo.cooperate_index)

        // this.linkInfo.link_spread_index.avg_value = this.changeW(this.pagelinkInfo.link_spread_index.avg_value)
        // this.linkInfo.link_shopping_index.avg_value = this.changeW(this.pagelinkInfo.link_shopping_index.avg_value)
        // this.linkInfo.link_convert_index.avg_value = this.changeW(this.pagelinkInfo.link_convert_index.avg_value)
        // this.linkInfo.cp_index.avg_value = this.changeW(this.pagelinkInfo.cp_index.avg_value)
        // this.linkInfo.cooperate_index.avg_value = this.changeW(this.pagelinkInfo.cooperate_index.avg_value)
        this.starPicRadar = {
            name: '',
            data: [
                {
                    value: [],
                    name: '达人指数',
                    itemStyle:{
                        color:'#59B1FF'
                    }
                },
                {
                    value: [],
                    name: '行业均值',
                    itemStyle:{
                        color:'#ff5c00'
                    }
                },
            ],
            indicator: [
                {
                    name: '传播指数',
                    max: 100,
                    min:0,
                },
                {
                    name: '合作指数',
                    max: 100,
                    min: 0,
                },
                {
                    name: '性价比指数',
                    max: 100,
                    min: 0,
                },
                {
                    name: '转化指数',
                    max: 100,
                    min: 0,
                },
                {
                    name: '种草指数',
                    max: 100,
                    min: 0,
                },
                ],
                custom:{
                    legend: {
                        show: true,
                        itemWidth: 8,
                        itemHeight: 8,
                        top: 0,
                        left: 0,
                        orient: 'horizontal',
                        textStyle: {
                            fontSize: 12,
                            color: 'color',
                            borderRadius:50
                        },
                    },

                }
        }
        let data1=[this.linkInfo.link_spread_index.value, this.linkInfo.cooperate_index.value, this.linkInfo.cp_index.value, this.linkInfo.link_convert_index.value, this.linkInfo.link_shopping_index.value,]
        let  data2 =[this.linkInfo.link_spread_index.avg_value, this.linkInfo.cooperate_index.avg_value, this.linkInfo.cp_index.avg_value, this.linkInfo.link_convert_index.avg_value, this.linkInfo.link_shopping_index.avg_value]
        let data = {}
        data.data1 = data1
        data.data2 = data2
        this.starPicRadar.data = this.starPicRadar?.data?.map((x,i)=>{
            x.value = data[`data${i+1}`]
            return x
        })

    },
    // create3(){
    //     //   获取达人热评词
    //     this.pageGetHotWord= JSON.parse(window.sessionStorage.getItem('getHotWord')).data.data
    //     this.hotWord = this.pageGetHotWord.hot_comment_tokens
    //     let hotwordEchartData = {
    //         nodeId:'hotwordEchart',//节点
    //         data: [],//数据
    //         color:["#ff5c00","#40a0fc"],
    //         xAxisData:[],
    //         min:0, //y轴的最小值
    //         max:500, //y轴最大值
    //         interval:100, //值之间的间隔
    //         yAxisName: '评论数',
    //         tooltipName:'评论数',
    //         unit:''//单位
    //     }
    //     this.pageGetHotWord?.hot_comment_tokens?.forEach(function(item,i){
    //         if(i<5){
    //             hotwordEchartData.xAxisData.push(item.comment_token)
    //             hotwordEchartData.data.push(item.hot_rate)
    //         }
    //     })
    //     hotwordEchartData.max = (Math.max.apply(null,hotwordEchartData.data)/100).toFixed(0)*100
    //     hotwordEchartData.interval = (hotwordEchartData.max-hotwordEchartData.min)/5
    //     this.hotwordEchartData = hotwordEchartData

    // },
    // create4(){
    //     //   获取达人热评词2
    //     this.pageGetHotWord2= JSON.parse(window.sessionStorage.getItem('getHotWord2')).data.data
    //     this.hotWord2=this.pageGetHotWord2
    //     this.hotWord2.expected_play_num = this.changeW(this.hotWord2.expected_play_num)
    // },
    create9(){
        let data = this.pageDarenCategory.main_category
        if(Object.keys(data).length>0){
            let commerceData=[]
            this.commerceIsShow=true
            for (let key in data){
                commerceData.push({value: data[key]*100,name:key})
            }
            this.commerceData.data=commerceData
            // this.$refs.outlineChart5.ringChart(this.commerceData)
        }else{
            this.commerceIsShow=false
        }
    },
    create10(){
        // this.sameDaren = this.pageSameDarenRec
        this.loadingObj.similarityTalent = false

    },
    videoClick(e,item){
      this.alertShow.isShow = true
      this.alertShow.src = item.video_id
      this.videoClickItem = item
    },
    onCopy(){
      alert('复制链接成功')
    },
    closeClick(){
      this.alertShow.isShow=false
    },
    videoMove(e,item){
        this.videoItems?.forEach(x=>{
            if(x.tagName == item.tagName){
                x.tagShow = false
            }
        })
        e.currentTarget.firstElementChild.className="videoWrap active"
        e.currentTarget.lastElementChild.play()
    },
    videoOut(e,item){
        this.videoItems?.forEach(x=>{
            if(x.tagName == item.tagName){
                x.tagShow = true
            }
        })
        e.currentTarget.firstElementChild.className="videoWrap"
        e.currentTarget.lastElementChild.pause()
    },
    scrollToTab2Video(){
      this.$emit('scrollToTab2Video');
    },
    //连接用户联动图表
    updateConnectUserChart(){
      this.connectUserChartInfo.data[0] = [
          {
              value: this.linkStruct?.link_struct['1']?.value,
              name: '了解',
              itemStyle: {opacity: this.linkStruct?.link_struct['1']?.value>0 ?1 :0}
          },
          {
              value: this.linkStruct?.link_struct['2']?.value,
              name: '兴趣',
              itemStyle: {opacity: this.linkStruct?.link_struct['2']?.value>0 ?1 :0}
          } ,
          {
              value: this.linkStruct?.link_struct['3']?.value,
              name: '喜欢',
              itemStyle: {opacity: this.linkStruct?.link_struct['3']?.value>0 ?1 :0}
          },
          {
              value: this.linkStruct?.link_struct['4']?.value,
              name: '跟随',
              itemStyle: {opacity: this.linkStruct?.link_struct['4']?.value>0 ?1 :0}
          }
         ]
      this.connectUserChartInfo.data[1] = [
          {
              value: this.linkStruct?.link_struct['1']?.same_industry_median,
              name: '了解',
              itemStyle: {opacity: this.linkStruct?.link_struct['1']?.same_industry_median>0 ?1 :0}
          },
          {
              value: this.linkStruct?.link_struct['2']?.same_industry_median,
              name: '兴趣',
              itemStyle: {opacity: this.linkStruct?.link_struct['2']?.same_industry_median>0 ?1 :0}
          },
          {
              value: this.linkStruct?.link_struct['3']?.same_industry_median,
              name: '喜欢',
              itemStyle: {opacity: this.linkStruct?.link_struct['3']?.same_industry_median>0 ?1 :0}
          },
          {
              value: this.linkStruct?.link_struct['4']?.same_industry_median,
              name: '跟随',
              itemStyle: {opacity: this.linkStruct?.link_struct['4']?.same_industry_median>0 ?1 :0}
          }
      ]
      this.$refs.connectUserChartRef.funnelChart(this.connectUserChartInfo)
      this.loadingObj.connectUserChartInfo = false
    },
    rowClassName ({ row }) {
        if (row.is_black == 1) {
            return 'row-gray'
        }
        return null
    },
    onCooperationDataChange(res){
        if(this.isCooperationExpand == false){
            this.isCooperationExpand = +res.totalCount > 0
        }
    }
  },

  mounted() {
    let _this = this
      //create2
    //   this.$refs.part1Chart.radarChart(this.starPicData)
      this.$refs?.part1Chart2?.lineChart(this.guanxingIndexData)
      //create3
    //   this.$refs?.part2Chart?.barChart(this.hotwordEchartData)
      //tab4Click
      this.$refs?.part4Chart?.lineChart(this.addFansData)
      //create9
      if(this.commerceIsShow){
        this.$nextTick(() => {
            this.$refs?.outlineChart5?.ringChart(this.commerceData)
        })
      }
      if(window.sessionStorage.getItem('getAuthorDrinfo')){
        this.initPart7Chart1Data(JSON.parse(window.sessionStorage.getItem('getAuthorDrinfo')))
      }
      this.$nextTick(function() {
      // 按下键盘
      document.addEventListener('keydown', function(e) {
        // Esc按键是27
        if (e.keyCode == 27) {
          //在这里写你的操作逻辑
          _this.closeClick()
        }
      });
    });
  }
}
</script>
<style lang="less" scoped>
    .el-dropdown-menu{
    height: 350px;
    overflow: auto;
    }
</style>
<style scoped>
.tips {
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    color: #4A5569;
    margin-bottom: 15px;
    i {
        color: #ff6f28;
        margin-right: 8px;
    }
}
  .noData{
    display: block;
    text-align: center;
    margin: 20px auto;
    color: #A1A1A1;
    padding-bottom: 30px;
  }
  .noDataBox img{
    display: block;
    margin: auto;
    padding-top: 30px;
  }
 #connectUserChart{
    width: 100%;
    height: 100%;
  }
.color-orange{
    color: #ED564E;
}
.color-green{
   color:  #0BB55A
}
    .list_box{
        /* width: 440px; */
        flex: 1;
        font-size: 12px;
        font-family: OPPOSans;
        color: #333333;
    }
    .list_box .Block{
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 4px;
    }
    .list_head,.list_item{
        display: flex;
        justify-content:space-between;
        padding: 18px 0;
        border-bottom: 1px solid #EFF1F1;

    }
    .list_head{
        color: #666;
        background-color: #FAFAFA;
    }
    .bigTitleBox{
        padding: 24px 0;
        border-bottom: 1px solid #F0F0F0;
        margin-bottom: 24px;
    }
    .bigTitle{
        font-size: 16px;
        /* font-weight: 600; */
        line-height: 22px;
    }
    .radar_box{
       margin-top: 16px;
       width: 378px;
       height: 310px;
     }
    .colorRed{
        margin-left: 8px;
        font-size: 12px;
        color: #ff5c00 !important;
    }
    .colorGreen{
        margin-left: 8px;
        font-size: 12px;
        color: #43D4B9 !important;
    }
    #part7Chart1Node{
        margin-top: -110px;
        width: 100%;
        height: 250px;
    }
    #commerceDataNode{
        margin-top: -20px;
        width: 100%;
        height: 210px;
    }
    .el-dropdown{
        float: right;
    }
    .el-dropdown-link {
        cursor: pointer;
        color: #FF5C00;
    }
    .el-icon-arrow-down {
        font-size: 12px;
    }
    #starPic{
        margin-top: 80px;
        width: 100%;
        height: 300px;
    }
    #addFans{
        position: absolute;
        top: 90px;
        right: 30px;
        width: 804px;
        height: 254px;
    }
    #hotwordEchart{
        margin-top: 40px;
        width: 402px;
        height: 254px;
    }
    #guanxingIndex{
        margin-top: -10px;
        width: 400px;
        height: 250px;
    }

    .chart {
      width: 100%;
    }
    .chart .chartItem{
        float: left;
        width: 50%;
        border-right: 1px solid #F0F0F0;
        box-sizing: border-box;
    }
    .chart .chartItem:nth-of-type(2){
        border-right: 0;
    }
    .chart .chartItem h5 {
        display: block;
        margin-top: 0;
        margin-bottom: 20px;
        padding-left: 30px;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
        box-sizing: border-box;
    }

  .top{
    width: 100%;
    height: 76px;
    margin-bottom: 12px;
    box-sizing: border-box;
    border-bottom: 1px solid #F0F0F0;
  }
   .top h5{
    display: inline-block;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
   .top i{
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #999999;
  }
  .top .tab{
    float: right;
    margin-left: 16px;
    margin-top: 22px;
  }
  .outlineContainer .part2 .top{
      width: 804px;
      margin-left: 30px;
  }
  .outlineContainer>>>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
    color: #FF5C00;
    background-color: #FFF2EB;
    border-color: #FF5C00;
    box-shadow: -1px 0 0 0 #FF5C00;
  }
  .outlineContainer>>>.el-radio-button__inner:hover{
    color: #333;
  }
  .outlineContainer>>>.el-radio-button__inner{
    padding: 10px 16px;
  }
  .outlineContainer>>>.el-radio-button:first-child .el-radio-button__inner{
    border-radius: 2px 0 0 2px;
  }
  .outlineContainer>>>.el-radio-button:last-child .el-radio-button__inner{
    border-radius: 0 2px 2px 0;
  }


    .outlineContainer{
        width: 100%;
    }
    .outlineContainer .part1{
        padding:0 24px 24px 24px;
        margin-bottom: 16px;
        box-sizing: border-box;
        width: 100%;
        min-height: auto;
        border-radius: 6px;
        background: #FFFFFF;
    }
    .outlineContainer .part1 .linkInfoPart{
        height: calc(100% - 70px);
        display: flex;
        justify-content: space-around;
    }
    .outlineContainer .part1 .linkInfoPart:nth-of-type(2){
        border-right: 0;
    }
    .outlineContainer .part1 .linkInfoPart.linkInfoPart2 .title i{
        float: right;
        color: #38A1FF;
    }
    .outlineContainer .part1 .linkInfoPart .title{
        display: flex;
        width: 100%;
        height: 16px;
        /* padding: 0 30px; */
        box-sizing: border-box;
    }
    .outlineContainer .part1 .linkInfoPart .title h5{

        margin: 0;
        line-height: 16px;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
    }
    .outlineContainer .part1 .linkInfoPart .title i{

        margin-left: 16px;
        line-height: 16px;
        font-size: 18px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #ff5c00;
    }
    .outlineContainer .part1 .linkInfoPart .title span{

        line-height: 16px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 400;
        cursor: pointer;
    }
    .linkInfoPart .rank{
        width: 100%;
        height: 100px;
        margin-top: 20px;
        padding-bottom: 23px;
        box-sizing: border-box;
        border-bottom: 1px solid #F0F0F0;
    }
    .linkInfoPart .rank .rankItem{
        display: inline-block;
        width: 50%;
        height: 100%;
        padding: 0 30px;
        border-right: 1px solid #F0F0F0;
        box-sizing: border-box;
    }
    .linkInfoPart .rank .rankItem:nth-of-type(2){
        border: 0;
    }
    .linkInfoPart .rank .rankItem span{
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
    }
    .linkInfoPart .rank .rankItem i{
        display: block;
        margin: 10px 0;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #333333;
    }
    .linkInfoPart .rank .rankItem p{
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #999999;
    }
    .linkInfoPart .rank .rankItem u{
        display: inline-block;
        margin: 0 4px;
        color: #FF5C00;
        text-decoration: none;
    }

    .linkInfoPart h5{
        padding-left: 20px;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
        box-sizing: border-box;
    }
    .part1 .linkInfoPart .title h5{
        padding-left: 0;
    }
    .outlineContainer .part2{
        width: 100%;
        height: 512px;
        margin-top: 16px;
        background: #FFFFFF;
        border-radius: 6px;
    }

    .outlineContainer .part2 ul{
        width: 100%;
        height: 100px;
        margin: 0;
        padding: 30px 0;
        box-sizing: border-box;
        border-bottom: 1px solid #F0F0F0;
    }
    .outlineContainer .part2 ul li{
        float: left;
        width: 25%;
        height: 100%;
        border-right: 1px solid #F0F0F0;
        list-style:none;
        text-align: center;
        box-sizing: border-box;
    }
    .outlineContainer .part2 ul li:nth-of-type(4){
        border: 0;
    }
    .outlineContainer .part2 ul li span{
        font-size: 18px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #333333;
    }
    .outlineContainer .part2 ul li p{
        position: relative;
        margin-top: 4px;
        margin-left: -14px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #666666;
        text-align: center;
    }
    .outlineContainer .part2 ul li p i{
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto 0;
        margin-left: 6px;
        width: 14px;
        height: 14px;
        cursor: pointer;
        background: url("../images/icon_6.png") no-repeat center;
    }

    .hotword {
        position: relative;
        margin-left: 50px;
        width: 340px;
        height: 260px;
    }
    .hotword  span{
        position: absolute;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #38A1FF;
    }
    .hotword  span:nth-of-type(1){
        top: 80px;
        left: 80px;
        font-size: 60px;
        color: #FF5C00;
    }
    .hotword  span:nth-of-type(2){
        top: 54px;
        left: 100px;
        font-size: 24px;
        color: #FF5C00;
    }
    .hotword  span:nth-of-type(3){
        top: 56px;
        left: 200px;
        font-size: 20px;
        color: #FFA555;
    }
    .hotword  span:nth-of-type(4){
        top: 160px;
        left: 110px;
        font-size: 20px;
        color: #FFA555;
    }
    .hotword  span:nth-of-type(5){
        top: 180px;
        left: 160px;
        font-size: 20px;
        color: #FF5C00;
    }
    .hotword  span:nth-of-type(6){
        top: 160px;
        left: 220px;
        font-size: 18px;
        color: #FFA555;
    }
    .hotword  span:nth-of-type(7){
        top: 30px;
        left: 120px;
        font-size: 16px;
        color: #38A1FF;
    }
    .hotword  span:nth-of-type(8){
        top: 100px;
        left: 10px;
        font-size: 14px;
        color: #38A1FF;
    }
    .hotword  span:nth-of-type(9){
        top: 130px;
        left: 26px;
        font-size: 14px;
        color: #38A1FF;
    }
    .hotword  span:nth-of-type(10){
        top: 200px;
        left: 80px;
        font-size: 14px;
        color: #38A1FF;
    }
    .part2 .chart .chartItem{
        border: 0;
    }

    /* edit */
  .part2{
    width: 100%;
    padding: 0 30px;
    background: #FFFFFF;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .part2 h5{
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part2 ul{
    width: 100%;
    padding: 0;
    overflow: hidden;
  }
  .part2 ul li{
    /* float: left; */
    width: 195px;
    height: 488px;
    margin-right: 30px;
  }
  .part2 ul li:nth-of-type(3n){
    margin-right: 0;
  }
  .part2 ul li .video{
    position: relative;
    width: 195px;
    height: 266px;
    background: #000000;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
  }
  .part2 ul li .video video{
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 100%;
  }
  .part2 ul li .video .videoWrap{
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    background:linear-gradient(rgba(0,0,0,0),rgba(0,0,0,.6))
  }
    .part3{
        width: 100%;
        height: 214px;
        margin-top: 16px;
        padding: 30px 0;
        background: #FFFFFF;
        border-radius: 6px;
        box-sizing: border-box;
    }
    .part3 .tab{
        margin-left: 30px;
    }
    .part3 .task .expect{
        width: 25%;
        margin-top: 10px;
    }
    .part3 .task .expect p i{
        left: 94px;
    }
    .part3 .expect,
    .part5 .expect{
        float: left;
        width: 30%;
        margin-top: 30px;
        margin-left: 30px;
    }
    .part3 .expect i,
    .part5 .expect i{
        font-size: 18px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #333333;
    }
    .part3 .expect p,
    .part5 .expect p{
        position: relative;
        margin-top: 6px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #666666;
    }
    .part3 .expect p i{
        position: absolute;
        top:1px;
        left: 56px;
        width: 14px;
        height: 14px;
        cursor: pointer;
        background: url("../images/icon_6.png") no-repeat center;
    }
    .part3 .chartItem .bottom{
        display: block;
        display: flex;
        justify-content: space-around;
        width: 372px;
        height: 42px;
        margin-top: 10px;
        margin-left: 30px;
        padding: 0 30px;
        background: #FAFAFA;
        box-sizing: border-box;
    }
    .part3 .task span{
        float: right;
        width: 30%;
        height: 100%;
        line-height: 42px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #333333;
        text-align: center;
    }
    .part4 {
        position: relative;
        width: 100%;
        height: 367px;
        margin-top: 16px;
        padding: 0 30px;
        background: #FFFFFF;
        border-radius: 6px;
        box-sizing: border-box;
    }
    .part4 .top{
        position: absolute;
        width: 804px;
        margin-bottom: 0;
    }
    .part4 .addFansData{
        position: absolute;
        top: 150px;
    }
    .part4 .addFansData .expect:nth-of-type(2){
        margin-top: 40px;
    }
    .part4 .addFansData i{
        font-size: 18px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #333333;
    }
    .part4 .addFansData p{
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #666666;
    }
    .part5 {
        width: 100%;
        height: 310px;
        padding: 0 30px;
        background: #FFFFFF;
        border-radius: 6px;
        margin-top: 14px;
        box-sizing: border-box;
    }
    .part5 .top{
        margin-bottom: 32px;
    }
    .part5 .chartItem{
        position: relative;
        border: 0;
        width: 50%;
    }
    .part5 .chartItem .title{
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
    }
    .part5 .chartItem .noData{
        position: absolute;
        top: 60px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 70px;
        text-align: center;
    }
    .part5 .chartItem .noData img{
        display: inline-block;
        width: 48px;
        height: 48px;
        margin-bottom: 14px;
    }
    .part5 .chartItem .noData span{
        display: block;
        display: inline-block;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #A1A1A1;
    }
    .part5 .expect{
        width: 50%;
        margin-left: 0;
    }

    .outlineContainer .part6{
        margin-top: 16px;
    }

    .bottemList {
        width: 864px;
        padding: 0 28px;
        background: #FFFFFF;
        border-radius: 6px;
        box-sizing: border-box;
    }

    .bottemList .title {
        width: 100%;
        height: 74px;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #333333;
        line-height: 74px;
    }

    .bottemList .title .titleLeft {
        float: left;
        height: 100%;
    }

    .bottemList .title .titleLeft i {
        color: #FF5500;
    }

    .bottemList .title .titleRight {
        position: relative;
        float: right;
        color: #666666;
        height: 100%;
    }

    .bottemList .title .titleRight .reflesh {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -22px;
        margin: auto 0;
        width: 16px;
        height: 16px;
        background: url("../images/icon_updata.png");
    }

    .bottemList .sameList {
        width: 100%;
        margin-top: 0;
        padding: 0;
        overflow: hidden;
    }

    .bottemList .sameList .top {
        width: 100%;
        height: 54px;
        margin-bottom: 0;
        border: 0;
    }

    .bottemList .sameList li {
        float: left;
        width: 248px;
        height: 264px;
        margin-right: 30px;
        margin-bottom: 30px;
        padding: 24px;
        background: #FFFFFF;
        border: 1px solid #E8E8E8;
        border-radius: 6px;
        box-sizing: border-box;
    }
    .bottemList .sameList li:hover {
        box-shadow:0px 0px 16px rgb(0, 0, 0, .2);
    }
    .bottemList .sameList li a{
        display: block;
    }
    .bottemList .sameList li:nth-of-type(3n) {
        margin-right: 0;
    }

    .bottemList .sameList .top .nameWrap {
        float: left;
        width: 70%;
    }

    .bottemList .sameList .top span {
        display: block;
        margin-bottom: 12px;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }

    .bottemList .sameList .top i {
        display: inline-block;
        margin-left: 0;
        margin-right: 6px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #666666;
    }

    .bottemList .sameList .top .imgWrap {
        float: right;
        width: 54px;
        height: 54px;
        border-radius: 50%;
        overflow: hidden;
    }

    .bottemList .sameList .top .imgWrap img {
        display: block;
        width: 100%;
        height: 100%;
    }

    .bottemList .sameList .center {
        width: 100%;
        overflow: hidden;
    }

    .bottemList .sameList .center .centerItem {
        float: left;
        width: 37%;
        margin-top: 16px;
    }

    .bottemList .sameList .center .centerItem:nth-of-type(3) {
        width: 26%;
    }

    .bottemList .sameList .center .centerItem span {
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #333333;
    }

    .bottemList .sameList .center .centerItem p {
        margin-top: 6px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #666666;
    }

    .bottemList .sameList .tag {
        border-radius: 2px;
        overflow: hidden;
        margin-top: 14px;
        margin-bottom: 14px;
    }

    .bottemList .sameList .tag span {
        background: #FFF2EB;
        float: left;
        height: 24px;
        line-height: 24px;
        margin-right: 10px;
        margin-bottom: 6px;
        padding: 0 10px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #FF5C00;
    }

    .bottemList .sameList .bottem {
        width: 100%;
        height: 20px;
        margin-top: 16px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 800;
        color: #FF5C00;
    }

    .bottemList .sameList .bottem .price {
        float: left;
    }

    .bottemList .sameList .bottem .other {
        position: relative;
        float: right;
    }

    .bottemList .sameList .bottem .other i {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -20px;
        margin: auto 0;
        width: 16px;
        height: 16px;
        background: url("../images/icon_comunication.png");
    }
    .part7 {
        position: relative;
        width: 100%;
        height: 367px;
        margin-top: 16px;
        padding: 0 30px;
        background: #FFFFFF;
        border-radius: 6px;
        box-sizing: border-box;
    }
    .part7 .noData{
        width: 100%;
        height: 100px;
        margin-top: -30px;
        text-align: center;
        color: #ccc;
    }
    .part7 .noData img{
        display: inline-block;
    }
    .part7 .noData span{
        display: block;
        margin-top: 20px;
        text-align: center;
    }
    .outlineContainer .videoBoxPart{

      padding: 0 24px 24px;
      margin-bottom: 16px;
      background: #fff;
      border-radius: 6px;
      box-sizing: border-box;
    }
    .outlineContainer .videoHeader{
      display: flex;
      line-height: 72px;
      justify-content: space-between;
      border-bottom: 1px solid #f0f0f0;
    }
    .outlineContainer .leftTitle{
      /* font-weight: 600; */
    }

    .outlineContainer .rightBtn{
      font-size: 14px;
      margin-right: 13px;
      cursor: pointer;
    }
    .outlineContainer .el-icon-arrow-right{
      position: relative;
      left: 72px;
    }
    .outlineContainer .videoList{
      display: flex;
      justify-content: space-between;
    }
    /* to do */
    .outlineContainer .card-panel{
        width: 100%;
        padding: 0 24px 24px 24px;
        background: #FFFFFF;
        border-radius: 6px;
        box-sizing: border-box;
        margin-top: 16px;
    }

  .ExpressionContainer .videoContent ul li .video {
      position: relative;
      width: 230px;
      height: 342px;
      background: #000000;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
  }

  .alertVideo{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    background: rgba(0,0,0,.5);
  }
  .alertVideo .videoCard{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    padding: 8px;
    width: 820px;
    height: 646px;
    background: #fff;
    border-radius: 6px;
  }
  .alertVideo .videoCard .videoBox{
    position: relative;
    float: left;
    width: 363px;
    height: 644px;
    border-radius: 4px;
    overflow: hidden;
    background: #000000;
  }
  .alertVideo .videoCard .videoBox video{
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 100%;
  }
  .alertVideo .videoCard .videoInfo{
    float: right;
    width: 390px;
    height: 100%;
    margin-right: 20px;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop{
    margin-top: 30px;
    overflow: hidden;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .photo{
    float: left;
    width: 60px;
    height: 60px;
    margin-top: 14px;
    margin-right: 18px;
    border-radius: 50%;
    box-sizing: border-box;
    overflow: hidden;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .photo img{
    width: 100%;
    height: 100%;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name{
    float: left;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name p{
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 0;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name i{
    display: inline-block;
    margin-right: 6px;
    color: #999;
    font-size: 14px;

  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name b{
    display: inline-block;
    color: #666;
    font-size: 14px;
  }
  .alertVideo .videoCard .videoInfo .tag{
    margin: 10px 0;
    overflow: hidden;
    display: inline-block;
  }
  .alertVideo .videoCard .videoInfo .tag span{
    float: left;
    color: #333;
    font-size: 12px;
    padding: 3px 8px;
    background: #eee;
    border-radius: 4px;
    margin-right: 8px;
  }
  .alertVideo .videoCard .videoInfo p{
    width: 100%;
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #333;
  }
  .alertVideo .videoCard .videoInfo .other{
    width: 100%;
  }
  .alertVideo .videoCard .videoInfo .other i{
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 10px;
    line-height: 18px;
    background: url("../images/icon_7.png") no-repeat center bottom;
    background-size: contain;
  }
  .alertVideo .videoCard .videoInfo .other i:nth-of-type(1){
    background-image: url("../images/icon_9.png");
    background-size: contain;
  }
  .alertVideo .videoCard .videoInfo .other i:nth-of-type(3){
    background-image: url("../images/icon_8.png");
    background-size: contain;
  }
  .alertVideo .videoCard .videoInfo .other b{
    display: inline-block;
    margin-right: 20px;
    font-size: 16px;
    color: #333;
    line-height: 18px;
  }
  .alertVideo .close{
    position: absolute;
    top:40px;
    right: 40px;
    width: 21px;
    height: 21px;
    background: url("../images/close.png") no-repeat center;
    cursor: pointer;
  }
  .videoCard .bottom{
    position: absolute;
    bottom: 20px;
    right: 30px;
    display: flex;
    width: 390px;
    align-items: center;
  }
  .videoCard .bottom a,
  .videoCard .bottom i{
    display: inline-block;
    margin-left: 10px;
    color: #38a1ff;
    font-size: 12px;
    cursor: pointer;
  }

  .videoContent{
    width: 100%;
    /* padding: 0 30px; */
    background: #FFFFFF;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .videoContent h5{
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .videoContent ul{
    width: 100%;
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    /* justify-content: space-between; */
    justify-content: start;
  }
  .videoContent ul li{
    position: relative;
    /* width: 195px; */
    /* height: 488px; */
        width: calc(25% - 12px);
        margin-right: 16px;
    }
  .videoContent ul li:nth-of-type(4n){
    margin-right: 0;
  }
  .videoContent ul li .video{
    position: relative;
    width: 100%;
    height: 398px;
    background: #000000;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
  }
  .videoContent ul li .video video{
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 100%;
  }
  .videoContent ul li .video .videoWrap{
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    background:linear-gradient(rgba(0,0,0,0),rgba(0,0,0,.6))
  }
  .videoContent ul li .video .videoWrap::after{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 1;
    content: '';
    width: 31px;
    height: 35px;
    background: url("../images/icon_play.png") no-repeat center;
  }

  .videoContent ul li p{
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
  }
  .videoContent ul li .tag i{
    display: inline-block;
    width: 11px;
    height: 11px;
    margin-right: 8px;
    background: url("../images/icon_1.png") no-repeat center;
  }
  .videoContent ul li .tag i:nth-of-type(1){
    width: 8px;
    height: 11px;
    background-image: url("../images/icon_3.png");
  }
  .videoContent ul li .tag i:nth-of-type(3){
    background-image: url("../images/icon_2.png");
  }
  .videoContent ul li .tag span{
    margin-right: 4px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #666666;
  }

  .user-connect-wrap .user-connect-chart-wrap{
    width: 571px;
    height: 250px;
    margin-top: 26px;
    position: relative;
  }

  .user-connect-wrap .label-container {
      width: 25%;
      position: relative;
      padding: 10px;
  }

  .user-connect-wrap .label {
      cursor: auto;
      line-height: 100%;
      font-size: 12px;
      font-family: sans-serif;
      pointer-events: auto;
      text-align: left;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-bottom: 2px;
      color: #333;
      font-weight: 500;
  }

  .user-connect-wrap .dot {
      cursor: auto;
      line-height: 100%;
      font-size: 12px;
      font-family: sans-serif;
      pointer-events: auto;
      text-align: left;
      color: #333;
      font-weight: 500;
      box-sizing: border-box;
      width: 8px;
      height: 8px;
      margin-right: 6px;
      background-color: #38a1ff;
      border-radius: 50%;
  }

  .user-connect-wrap .value {
      cursor: auto;
      pointer-events: auto;
      text-align: left;
      box-sizing: border-box;
      font-size: 12px;
      line-height: 20px;
      color: #999;
      font-family: OPPOSans;
  }

  .user-connect-wrap .label-group{
      display: flex;
      position: absolute;
      bottom: -20px;
      width: 100%;
  }

  .user-connect-wrap .content-container {
      display: flex;
      width: 100%;
      height: 300px;
  }

  .user-connect-wrap .right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 24px;
      padding: 0 24px;
      border: 1px solid #F0F0F0;
      color: #666;
      border-radius: 8px;
  }

  .user-connect-wrap .type-title {
      color: #ff5c00;
      font-weight: 500;
  }

  .user-connect-wrap .section-title {
      margin: 16px 0 8px;
      color: #333;
      font-weight: 500;
  }
  .flex-box{
      display: flex;
      align-items: center;
  }
  .Toptag{
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 10;
    height: 25px;
    padding: 0 12px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 12px;
    line-height: 25px;
    background-color: #fff;
    border-radius: 100px;
  }
  .noToptag{
    display: none;
  }
</style>
<style lang="scss" scoped>
    ::v-deep .vxe-table .vxe-body--row.row-gray{
        background-color: #F2F3F5;
    }
</style>